// extracted by mini-css-extract-plugin
module.exports = {"icon":"icon_icon___L1OO"};